import { Link } from 'react-router-dom';
import { PawPrint } from '@phosphor-icons/react';

export function Footer() {
  return (
    <footer className="py-12 bg-muted/50 border-t" data-testid="footer">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-3">
              <div className="w-8 h-8 rounded-full bg-primary flex items-center justify-center">
                <PawPrint weight="fill" className="w-5 h-5 text-primary-foreground" />
              </div>
              <span className="font-bold font-outfit">PasseioPerfeito</span>
            </Link>
            <p className="text-sm text-muted-foreground">
              O melhor cuidado para o seu pet em Portugal.
            </p>
          </div>

          {/* Plataforma */}
          <div>
            <h4 className="font-semibold text-sm mb-3">Plataforma</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/como-funciona" className="text-sm text-muted-foreground hover:text-primary transition-colors" data-testid="footer-how-it-works">
                  Como Funciona
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-sm text-muted-foreground hover:text-primary transition-colors" data-testid="footer-faq">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/seguranca" className="text-sm text-muted-foreground hover:text-primary transition-colors" data-testid="footer-security">
                  Segurança e Confiança
                </Link>
              </li>
            </ul>
          </div>

          {/* Empresa */}
          <div>
            <h4 className="font-semibold text-sm mb-3">Empresa</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/sobre" className="text-sm text-muted-foreground hover:text-primary transition-colors" data-testid="footer-about">
                  Sobre Nós
                </Link>
              </li>
              <li>
                <Link to="/contactos" className="text-sm text-muted-foreground hover:text-primary transition-colors" data-testid="footer-contact">
                  Contactos
                </Link>
              </li>
              <li>
                <Link to="/termos" className="text-sm text-muted-foreground hover:text-primary transition-colors" data-testid="footer-terms">
                  Termos e Condições
                </Link>
              </li>
            </ul>
          </div>

          {/* Contacto */}
          <div>
            <h4 className="font-semibold text-sm mb-3">Contacto</h4>
            <ul className="space-y-2">
              <li className="text-sm text-muted-foreground">
                suporte@passeioperfeito.pt
              </li>
              <li className="text-sm text-muted-foreground">
                928 314 198
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-muted-foreground">
            &copy; {new Date().getFullYear()} PasseioPerfeito. Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-4">
            <Link to="/termos" className="text-xs text-muted-foreground hover:text-primary transition-colors">
              Termos
            </Link>
            <Link to="/seguranca" className="text-xs text-muted-foreground hover:text-primary transition-colors">
              Privacidade
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
